import {
  createFileRoute,
} from '@tanstack/react-router';

import Invite from '#features/auth/invite/Invite';
import {
  inviteTokenSearchSchema,
} from '#src/types/inviteToken';

export const Route = createFileRoute('/_app/invite/existing')({
  component: Invite,
  validateSearch: inviteTokenSearchSchema,
});
